import type BigNumber from 'bignumber.js';
import { api_matcha } from './utils';
import type { IMatchaResponse } from '$lib/web3/types';
import { FEE_RECIPIENT, POLYNOMIAL_FEE } from '$lib/web3/contants';

function sleep(milliseconds: number) {
	return new Promise((resolve) => setTimeout(resolve, milliseconds));
}

function getMillisToSleep(retryHeaderString: string) {
	let millisToSleep = Math.round(parseFloat(retryHeaderString) * 1000);
	return millisToSleep;
}

export async function fetchAndRetryIfNecessary(
	sellToken: string,
	buyToken: string,
	sellAmount: BigNumber,
	swapSlippage: string
) {
	if (!sellToken || !buyToken || !sellAmount || !swapSlippage) return;
	const response = await api_matcha(
		'get',
		`swap/v1/quote?sellToken=${sellToken}&buyToken=${buyToken}&sellAmount=${sellAmount.toFixed(
			0
		)}&slippagePercentage=${swapSlippage}&buyTokenPercentageFee=${POLYNOMIAL_FEE}&feeRecipient=${FEE_RECIPIENT}`
	);

	if (response.status === 429) {
		const retryAfter = response.headers.get('retry-after');
		const millisToSleep = getMillisToSleep(retryAfter as string);
		await sleep(millisToSleep);
		return fetchAndRetryIfNecessary(sellToken, buyToken, sellAmount, swapSlippage);
	}
	if (response.status == 200) {
		const data: IMatchaResponse = await response.json();
		return data;
	}
}

export async function api_matcha_calldata(
	sellToken: string,
	buyToken: string,
	sellAmount: BigNumber,
	swapSlippage: string
) {
	if (!sellToken || !buyToken || !sellAmount || !swapSlippage) return;
	const response = await api_matcha(
		'get',
		`swap/v1/quote?sellToken=${sellToken}&buyToken=${buyToken}&sellAmount=${sellAmount.toFixed(
			0
		)}&slippagePercentage=${swapSlippage}&buyTokenPercentageFee=${POLYNOMIAL_FEE}&feeRecipient=${FEE_RECIPIENT}`
	);
	if (response.status == 200) {
		const data: IMatchaResponse = await response.json();
		return data;
	}
}
